import { css } from '@emotion/react';
import { semanticTokens } from '@flysas-tech/commercial-ui';
import { PropsWithChildren } from 'react';

const styles = css`
  all: unset;
  cursor: pointer;
  text-decoration: underline;
  color: ${semanticTokens.color.text['link-secondary']};

  &:hover {
    color: ${semanticTokens.color.text['link-secondary-hover']};
  }

  &:focus-visible {
    outline: 2px solid ${semanticTokens.color.border.focus};
  }
`;

type ButtonAsLinkProps = {
  onClick: () => void;
  className?: string;
};

export const LinkAsButton = ({ children, onClick, className }: PropsWithChildren<ButtonAsLinkProps>) => {
  return (
    <button css={styles} onClick={onClick} className={className}>
      {children}
    </button>
  );
};
